import {commitMutation, graphql} from 'react-relay';
import environment from '../../../environment';

const mutation = graphql`
  mutation randomizeFrontSquareBoxByGuestMutation($input: randomize_front_square_box_by_guest_mutationInput!) {
    randomizeFrontSquareBoxByGuest(input: $input) {
      code
      message
    }
  }
`;

function randomizeFrontSquareBoxByGuest(data, callback) {

  const variables = {
    input: data,
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,     
      onCompleted: (response, errors) => {
        callback(response)
      },
      onError: err => console.error(err),
    },
  );

}

export default randomizeFrontSquareBoxByGuest;
